import Vue from 'vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.less';
Vue.use(Antd);

// confirm被elementui覆盖了
Vue.prototype.$antdConfirm = Vue.prototype.$confirm;